module.exports = __webpack_public_path__ + "img/sol_cap1.74b44a27.png";